import documentInit from './modules/document';
import mobileNavInit from './modules/mobile-nav';
import navInit from './modules/nav';
import slickInit from './modules/slick';
import miscInit from './modules/misc';
import csFiltersInit from './modules/cs-filters';
import loadmoreInit from './modules/loadmore';
import niceSelectInit from './modules/nice-select';

(function ($) {

	$(document).ready(function () {

		documentInit();
		navInit();
		mobileNavInit();
		slickInit();
		miscInit();
		csFiltersInit();
		loadmoreInit();
		niceSelectInit();

		$(window).trigger('resize');
		$(window).trigger('scroll');
		$(window).trigger('hp-plugins-loaded');

	});

})(jQuery);